module.exports = __webpack_public_path__ + "static/award3-3ff2a1042866591971c22cf9e4da9a67.png";